import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { parseTheme } from '../../utils/common'

import darkBkImg from '../../../assets/images/gray-bk-hex.png'

function NonAuthHeader({overrideTheme, showDemoButton}){
    const theme = parseTheme()
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    const location = useLocation();
    return <nav class="navbar">
        <div class="container">
            <Link to="/" class="navbar-brand">
                <img class="logoTop" style={{height: "80px"}} src={theme?.secondaryLogo ?? "https://engine.internetstrategylabs.com/images/insights-engine-white.png"} alt="Insights Engine White Logo" />
            </Link>
            <div class="d-flex" style={{gridColumnGap: "1em", gridRowGap: "1em"}}>
                <Link class="btn btn-link text-white" to={location.pathname?.includes("/welcome") ? "/login" : "/welcome"}>
                    {location.pathname?.includes("/welcome") ? "Login" : "Get Started Free" }
                </Link>
                {showDemoButton && <a class="btn btn-primary" href="https://internetstrategylabs.com">Get a Demo</a>}
            </div>
        </div>
        <div class="navbar-button-bg"></div>
    </nav>
}

NonAuthHeader.defaultProps = {
    showDemoButton: true
}

export default NonAuthHeader